export const REFRESH_NFT_OF_THE_DAY_UPDATE_TOKEN = 'REFRESH_NFT_OF_THE_DAY_UPDATE_TOKEN';
export const RESET_NFT_OF_THE_DAY_DATA = 'RESET_NFT_OF_THE_DAY_DATA';
export const FETCH_NFT_OF_THE_DAY = 'FETCH_NFT_OF_THE_DAY';
export const FETCH_NFT_OF_THE_DAY_ASSETS = 'FETCH_NFT_OF_THE_DAY_ASSETS';
